import { useRef, CSSProperties } from 'react';
import VideoModalLandscape from 'pages/MarketingPage/Components/VideoModalLandscape';
import Colors from 'modules/Colors';
import ButtonSymphony from 'elements/ButtonSymphony';
import useModal from 'Hooks/useModal';
import { CONVERSIONS_VIDEOS } from 'modules/Types';
import Icon from 'elements/Icon';
import Sty from 'modules/Sty';
import { clsx, styx } from 'modules/Utils';
import useScreen from 'Hooks/useScreen';

const { stepVideos } = CONVERSIONS_VIDEOS;

interface ConnectionsCampaignView_RIGHTProps {
    className?: string;
    variant: 'facebook' | 'tiktok'
}

const ConnectionsCampaignView_RIGHT = ({
    className,
    variant = 'facebook'
}: ConnectionsCampaignView_RIGHTProps) => {
    const parent = useRef<HTMLDivElement>(null);
    const videoModal = useModal();
    const { mStyle } = useScreen();
    const videoData = {
        title: 'Getting Started with Symphony',
        videoUrl: stepVideos.GETTING_STARTED.videoUrl,
        thumbnail: stepVideos.GETTING_STARTED.thumbnail,
        description: stepVideos.GETTING_STARTED.description,
    };

    return (
        <div
            className={clsx('videoContainer2', className)}
            ref={parent}
            style={styx(
                mStyle(sty, 'videoContainer2'),
                { backgroundImage: `url(${videoData.thumbnail})` }
            )}
        >
            <div className="videoCoverOverlay" style={sty.videoCoverOverlay} />
            <div className="headlineContainer" style={sty.headlineContainer}>
                <div className="headlineTitle" style={Sty.text24white}>
                    {videoData.title}
                </div>
                {videoData.description &&
                    <div className="headlineDescription" style={Sty.text16white}>
                        {videoData.description}
                    </div>
                }
                <ButtonSymphony
                    className="stepVideoContainerButton2"
                    onClick={videoModal.openModal}
                    color="white"
                    iconLeft={
                        <Icon
                            className="stepVideoContainerButton2Icon"
                            icon="play"
                            size={18}
                        />
                    }
                >
                    Watch video
                </ButtonSymphony>
            </div>
            <VideoModalLandscape
                title={videoData.title}
                videoUrl={videoData.videoUrl}
                description={videoData.description}
                open={videoModal.open}
                closeModal={videoModal.closeModal}
            />
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    videoContainer2: {
        position: 'relative',
        width: '100%',
        height: 472,
        borderRadius: 8,
        padding: 16,
        backgroundSize: 'cover',
        overflow: 'hidden',
    },
    videoContainer2_mobile: {
        height: 216,
    },
    videoContainer2_medium: {
        height: 340,
    },
    videoCoverOverlay: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: Colors.DARK_VIDEO_HOVER_LAYOUT,
        left: 0,
        top: 0,
    },
    headlineContainer: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        bottom: 28,
        maxWidth: '90%',
    },
    videoIconStroke: {
        height: 16,
        width: 16,
    },
};

export default ConnectionsCampaignView_RIGHT;
